const profileSettings = {
  loadFailed: "Ekki tókst að sækja notandaupplýsingar",
  loadingProfile: "Sæki notandaupplýsingar...",
  title: "Notandaupplýsingar og stillingar",
  profileInfo: {
    heading: "Notandaupplýsingar",
    institution: "Stofnun",
    accountStatus: "Staða aðgangs",
    active: "Virkur",
    inactive: "Óvirkur",
    accountCreated: "Aðgangur stofnaður",
  },
  roleBanner: {
    orgAdmin: {
      title: "👑 Stjórnandi stofnunar",
      description: "Þú hefur fullar stjórnunarheimildir í þessu kerfi",
    },
    pi: {
      title: "Hlutverk: Verkefnisstjóri",
      description:
        "Þú hefur stjórnunarheimildir til að stýra verkefnum og notendum",
    },
  },
  security: {
    heading: "Öryggisstillingar",
    changePassword: "Breyta lykilorði",
    changePasswordHint: "Uppfærðu lykilorðið þitt til að tryggja öryggi aðgangsins",
    changing: "Breyti...",
    successMessage: "Lykilorði var breytt!",
    currentPasswordLabel: "Núverandi lykilorð *",
    newPasswordLabel: "Nýtt lykilorð *",
    confirmPasswordLabel: "Staðfesta nýtt lykilorð *",
    passwordRequirement: {
      minLength: "Verður að vera að minnsta kosti {{minLength}} stafir",
      uppercase: ", hástafur",
      lowercase: ", lágstafur",
      digit: ", tölustafur",
      specialChar: ", sérstafur",
    },
    twoFactorLabel: "Tvíþátta auðkenningarkóði *",
    twoFactorPlaceholder: "000000",
    twoFactorHint: "Sláðu inn 6 stafa kóðann úr auðkenningarappinu þínu",
  },
  errors: {
    policyNotLoaded: "Lykilorðastefna hlóðst ekki. Reyndu aftur.",
    passwordMismatch: "Ný lykilorð stemma ekki",
    samePassword: "Nýtt lykilorð verður að vera frábrugðið núverandi lykilorði",
    twoFactorRequired: "Sláðu inn 6 stafa tvíþátta kóðann þinn",
    changeFailed: "Ekki tókst að breyta lykilorði",
  },
};

export default profileSettings;
